import type { Diagram } from "../shared/companion";
import type { ReflectionEntry, DiagResultEntry, Suggestion } from "./api";

export interface ChatMessage {
  id?: string;
  role: "user" | "assistant";
  shown: string; // text currently displayed (streams in)
  full: string; // complete text once known
  pending?: boolean;
  done?: boolean;
  diagram?: Diagram | null;
  cites?: string[];
  saved?: boolean;
}

export interface SessionUser {
  id: string;
  email: string;
  name: string | null;
  picture: string | null;
  challenge: string | null;
}

export type Route = "home" | "wiki" | "framework" | "session" | "patterns" | "practice" | "suggestions" | "account";
export type WikiTab = "frameworks" | "sessions" | "lexicon";
export type ViewState = "returning" | "firstRun";

export interface AppState {
  // auth / boot
  authed: boolean;
  loading: boolean;
  authError: string | null;
  user: SessionUser | null;

  // navigation
  route: Route;
  viewState: ViewState;
  wikiTab: WikiTab;
  frameworkId: string;
  sessionId: string;

  // companion
  companionOpen: boolean;
  companionWide: boolean;
  challengeMode: boolean;
  messages: ChatMessage[];
  sending: boolean;
  challenge: string;
  editingChallenge: boolean;
  confirmClear: boolean;

  // mobile nav drawer
  navOpen: boolean;

  // search + account
  searchOpen: boolean;
  query: string;
  accountMenuOpen: boolean;
  confirmDelete: boolean;

  // practice
  practiceTab: "labs" | "diagnostics";
  activeLab: string | null;
  reflections: Record<string, ReflectionEntry>;
  reflectionsLoaded: boolean;
  diagResults: Record<string, DiagResultEntry>;
  activeDiagnostic: string | null;
  diagAnswers: Record<string, number>;
  diagOutcome: string | null; // computed outcome key after submit

  // patterns
  patternFilter: string; // "all" or a theme

  // suggestions
  suggestions: Suggestion[];
  suggestionsLoaded: boolean;
  suggestionSort: "new" | "top";
  suggestionAnon: boolean;
}

export function initialState(): AppState {
  return {
    authed: false,
    loading: true,
    authError: null,
    user: null,
    route: "home",
    viewState: "returning",
    wikiTab: "frameworks",
    frameworkId: "clark",
    sessionId: "reitz",
    navOpen: false,
    companionOpen: true,
    companionWide: false,
    challengeMode: false,
    messages: [],
    sending: false,
    challenge: "",
    editingChallenge: false,
    confirmClear: false,
    searchOpen: false,
    query: "",
    accountMenuOpen: false,
    confirmDelete: false,
    practiceTab: "labs",
    activeLab: null,
    reflections: {},
    reflectionsLoaded: false,
    diagResults: {},
    activeDiagnostic: null,
    diagAnswers: {},
    diagOutcome: null,
    patternFilter: "all",
    suggestions: [],
    suggestionsLoaded: false,
    suggestionSort: "top",
    suggestionAnon: false,
  };
}
